<template>
	<v-app>
		<v-row class="px-4">
      <v-col cols="12">
        <v-card
          elevation="0"
          style="margin-top: 15px;">
          <v-card-title>
            <v-row>
              <v-col class="auto">
                {{ $t('_historique_de_sous_performance_') }}
              </v-col>

              <v-col class="col-2">
                  <dates-selector
                      :store_date="$store.getters.niv2Dates"
                      :min_date="auditDates.start"
                      :max_date="auditDates.end"
                      :show_label="false"
                      :default_last_month="false"
                      store_cal_event="SET_NIV2_CALENDAR_REFRESH"
                      store_date_commit="SET_NIV2_DATES"
                  />
                <slot></slot>
              </v-col>

              <v-col class="col-2">
                <v-select
                  v-model="time_step"                  
                  :items="time_step_list"
                  style="padding-top: 0px;"
                  @change ="select_value_time_step"
                  dense
                ></v-select>
             </v-col>

              <v-col class="col-sm-4" >
                <tree-select
                  v-model="pdm_values"
                  :auto-load-root-options=false
                  :defaultExpandLevel="expand_level"
                  :disable-branch-nodes=true
                  :load-options="getAllPdmTree"
                  :multiple=false
                  :options="pdm_options"
                  :showCount=true
                  :placeholder="$t('_selectionner_un_point_de_mesure_')"
                  v-on:input="changePdm(pdm_values)"
                >
                  <div slot="value-label" slot-scope="{ node }">{{ node.raw.customLabel }}</div>
                </tree-select>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>

        <v-card
          elevation="0"
        >
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-card elevation="0">
                  <LoadingDialog
                    v-if="loading"
                    :is_loading="loading"
                  ></LoadingDialog>
                  <plotly-graph
                      :dates="dates"
                      :graph_data="graph_data"
                      @update-selected-date="updateSelectedDate($event)"
                      style="padding: 20px;"
                      v-else
                  />
                 <!--  <v-btn @click="downloadData(graph_data)">{{ $t("_telecharger_le_tableau_comparatif_") }}</v-btn> Hidden -->
                  <v-btn v-if="is_Month_or_year"  @click="downloadDataAndPower()">{{ $t("_telecharger_le_tableau_comparatif_") }}</v-btn>
                </v-card>
             </v-col>
             
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card elevation="0" v-if="pdm_values">
                  <LoadingDialog v-if="loading" :is_loading=loading></LoadingDialog>
                  <plotly-graph
                      :dates="dates"
                      :graph_data="graph_data_pdm"
                      @update-selected-date="updateSelectedDate($event)"
                      style="padding: 20px;"
                      v-else
                  />
                  <v-btn v-if="pdm_values"  @click="downloadData(graph_data_pdm, current_pdm)">{{ $t("_telecharger_le_tableau_comparatif_") }}</v-btn>
                </v-card>
             </v-col>
             
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
		</v-row>
	</v-app>
</template>

<script>

import api from "@/api/api.js";
import cd from '@/utils/compute_data.js';
import LoadingDialog from "@/components/Utils/LoadingDialog";
import DatesSelector from "@/components/Utils/DatesSelector"
import PlotlyGraph from '@/components/Plotly/PlotlyGraph';
import TreeSelect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'


export default {
    components:{
        LoadingDialog,
        DatesSelector,
        PlotlyGraph,
        TreeSelect
    },

	data() {
		return {
      loading: false,
      is_Month_or_year:true,
			// Params
			installation_id: this.$route.params.id,
      current_pdm: null,
      selectedDate: null,    
      query_param: {
        "date_interval": "monthly"
      },

      time_step: "monthly",
      time_step_list: [],

      // Graphic
      expand_level: 0,
      graph_data: {},
      graph_data_pdm: {},

      pdm_values: null,
      pdm_options: []
		};
	},

  computed: {
    dates() {
        return this.$store.state.parametersStore.dates
    },

    installation() {
        return this.$store.getters.installations.find(
            (x) => x.id == this.$route.params.id
        );
    },

    auditDates() {
      return this.$store.state.parametersStore.dates
    },
    canNavigate() {
      return this.installation.elec_var.includes("Pac@grid")
    },

  },

	watch: {
    '$route': {
      async handler() {
        this.refreshTimeStep()
        await this.getAllPdmTree()
        await this.renderModel()
        await this.renderPdmModel()
      },
      immediate: true,
    },

    async dates() {
      await this.renderModel();
      await this.renderPdmModel()
    },

    async time_step() {
      this.query_param['date_interval'] = this.time_step
      await this.renderModel()
      await this.renderPdmModel()
      
    },   
    
    
    async '$store.getters.niv2CalendarRefresh'() {
      if (this.$store.getters.niv2CalendarRefresh) {
        this.$store.commit('SET_NIV2_CALENDAR_REFRESH', false)
        await this.renderModel()
        await this.renderPdmModel()
      }
     },

    async '$root.$i18n.locale'() {
      this.refreshTimeStep()
      await this.getAllPdmTree()
      await this.renderModel()
      await this.renderPdmModel()
    },

	},

	methods: {
    select_value_time_step(){
       if(this.time_step==='monthly' || this.time_step==='yearly'){
        this.is_Month_or_year=true
       }else
       {
        this.is_Month_or_year=false
       }
    },
    async downloadDataAndPower(){
      //1. La requete pour recupere les data du "graphe" + les énergies (ou fusionner)
      //2. La requete de conversion en JSON

      //Help s'inspirer de la fonction ci-desosus
      let report_name = null
      let target_menu = null
      if(this.getdc_analysis()===true){
        target_menu = this.getMenu()
         await api
          .getReportFullName(this.$route.name , target_menu)
          .then((res_mod) => {
            report_name =res_mod.data[2][3]
            
          })
      }
        else {
          target_menu = 'continuous'
          await api
          .getReportFullName(this.$route.name , target_menu )
          .then((res_mod) => {
            report_name =res_mod.data[2][3]   
            
          })
        }

      var myDatas = {}
      this.query_param['pacgrid'] = this.installation.elec_var.includes("Pac@grid")
      await api
            .getTemplateRenderByName(report_name, this.$root.$i18n.locale, this.query_param)
            .then((res) => {
              myDatas['data_render'] = res['data']['data']
              myDatas['layout_render'] = res['data']['layout']
              this.loading = false
            });     
      

      console.log("telechartger tableau")
      this.downloadData(myDatas,"") 

     
    },


    downloadData(data, pdm=""){


      api.convertJsonSousPerf(
        {"data":data}, 
        "xlsx", 
        "plotly_diagram_bar", 
         this.$root.$i18n.locale )
            .then((res)=>{
              let name = this.$t('_historique_de_sous_performance_') +"_"+ pdm + "_"+ this.$route.params.id + "_.xlsx"
              let a = document.createElement('a');
              a.href = URL.createObjectURL(res.data) ;
              a.download = name;
              a.click();}
            )

    },

    getMenu() {
      return this.$store.getters.installations.find(x => x.id == this.$route.params.id)?.target_menu
    },
    getdc_analysis() {
      return this.$store.getters.installations.find(x => x.id == this.$route.params.id)?.dc_analysis
    },
    refreshTimeStep() {
      this.time_step_list = [
          {
              'text': this.$t('_quotidien_'),
              'value': 'daily'
          },
          {
              'text': this.$t('_hebdomadaire_'),
              'value': 'weekly'
          },
          {
              'text': this.$t('_mensuel_'),
              'value': 'monthly'
          },
          {
              'text': this.$t('_annuel_'),
              'value': 'yearly'
          }
      ]
      if(this.time_step_list[0][1]==='monthly')
      {
        console.log(this.time_step_list[0][1])
      }
    },

    async renderModel() {
        this.loading = true
        let report_name = null  
         await api
        .getReportFullName(this.$route.name , this.getMenu() )
        .then((res_mod) => {
            report_name = res_mod.data[0][1]
          })

        this.query_param['installation_id'] = this.installation.id
        this.query_param['start_date'] = this.$store.getters.niv2Dates.start
        this.query_param['end_date'] = this.$store.getters.niv2Dates.end
        this.query_param['sel_pdm'] = null
        this.query_param['export_type'] = null
        this.query_param['pacgrid'] = this.installation.elec_var.includes("Pac@grid")
        await api
            .getTemplateRenderByName(report_name, this.$root.$i18n.locale, this.query_param)
            .then((res) => {
              this.graph_data['data_render'] = res['data']['data']
              this.graph_data['layout_render'] = res['data']['layout']
              this.loading = false
            });
      },

    async renderPdmModel() {
      if (this.current_pdm === undefined || this.current_pdm === null) return
      this.loading = true

      let report_name = null
      await api
        .getReportFullName(this.$route.name, this.getMenu())
        .then((res_mod) => {
          report_name = res_mod.data[1][2]
        })

      this.query_param['installation_id'] = this.installation.id
      this.query_param['start_date'] = this.$store.getters.niv2Dates.start
      this.query_param['end_date'] = this.$store.getters.niv2Dates.end
      this.query_param['sel_pdm'] = cd.parsePdmId(this.current_pdm)
      this.query_param['export_type'] = null
      this.query_param['pacgrid'] = this.installation.elec_var.includes("Pac@grid")
      await api
          .getTemplateRenderByName(report_name, this.$root.$i18n.locale, this.query_param)
          .then((res) => {
            this.graph_data_pdm['data_render'] = res['data']['data']
            this.graph_data_pdm['layout_render'] = res['data']['layout']
            this.loading = false
          });
    },

    async getAllPdmTree() {
      const langcode = this.$root.$i18n.locale

      await api
        .getPdmTree(this.installation.id, langcode)
        .then((res) => {
          this.pdm_options = []
          res.data['tree'].map((elm) => this.pdm_options.push(elm));
          this.expand_level = res.data['expand_level']
        });
    },

    updateSelectedDate(date) {
      this.selectedDate = date
    },

    async changePdm(pdm) {
      if (pdm !== undefined && pdm !== null) {
        this.current_pdm = pdm
        this.pdm_changed = true
        await this.renderPdmModel()
        this.pdm_changed = false
      } else {
        this.current_pdm = null
      }
    }

	},
};
</script>

<style scoped>
.v-select-like {
  border: 1px solid black !important;
  width: 100%;
  display: block;
  border-radius: 4px;
  outline: none;
  color: black;
}

.vue-treeselect {
  font-size: 0.9rem;
  font-weight: normal;
  padding-top: 0px;
}

.v-card__subtitle,
.v-card__text,
.v-card__title {
  padding: 16px 16px 0px 16px;
  border-bottom: #eee solid 1px;
}

html {
  overflow: hidden !important;
}
</style>
